import React from 'react';
import styled, { css } from 'styled-components';
import { tokens } from '@carta/ink';

import { defaultText } from './StyledText';

interface StyledAnchorProps {
  variant?: 'default' | 'dark' | 'small';
  preset?: 'new-tab' | 'default';
}

const StyledAnchor = styled.a<StyledAnchorProps>`
  ${defaultText}
  text-decoration-line: underline;
  text-underline-offset: auto;
  text-underline-position: from-font;
  text-decoration-color: ${tokens.color.global.font.hierarchy.body.default};

  ${props =>
    props.variant === 'small' &&
    css`
      font-size: 12px;
    `}

  ${props =>
    props.preset === 'new-tab' &&
    css`
      &::after {
        content: '↗';
        display: inline-block;
        line-height: 1;
        margin-left: 4px;
      }
    `}

  &:hover {
    color: ${tokens.color.global.font.link.base.hover};
    text-decoration: none;
    cursor: pointer;
  }

  ${props =>
    props.variant === 'dark' &&
    css`
      color: ${tokens.color.global.font.custom.white.default};
      text-decoration-color: ${tokens.color.global.font.custom.white.default};

      &:hover {
        color: ${tokens.color.global.font.link.inverse.down};
        text-decoration: none;
      }
    `}
`;

export default StyledAnchor;
